exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".build-dropdown{max-height:300px;overflow:auto;overflow-x:hidden}.build-dropdown::-webkit-scrollbar{width:8px;height:4px}.build-dropdown::-webkit-scrollbar-thumb{border-radius:5px;height:8px;background:rgba(0,0,0,0.2)}.build-dropdown::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 5px rgba(0,0,0,0.2);box-shadow:inset 0 0 5px rgba(0,0,0,0.2);border-radius:5px;background:#eee}\n", ""]);

// exports
